module.exports = __webpack_public_path__ + "static/media/plus-grey.d90857c4.svg";